export default __webpack_public_path__ + "static/media/pantry2-after1-1920w.30437d93.webp";